<template>
  <expandable-material-card
    :title="$t('components.portal.student_wellness')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="web_asset"
  >
    <v-card-text v-if="innerItem !== null && innerItem !== undefined">
      <v-form v-model="valid">
        <v-layout row wrap>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              :label="$t('components.portal.student_wellness.student_code')"
              :value.sync="innerItem.StudentCode"
              clearable
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              :label="$t('components.portal.student_wellness.student_id')"
              :value.sync="innerItem.StudentId"
              clearable
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              :label="$t('components.portal.student_wellness.external_website')"
              :value.sync="innerItem.ExternalWebsite"
              clearable
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              :label="$t('components.portal.student_wellness.google_play_url')"
              :value.sync="innerItem.GooglePlayUrl"
              clearable
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              :label="$t('components.portal.student_wellness.app_store_url')"
              :value.sync="innerItem.AppStoreUrl"
              clearable
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              :label="$t('components.portal.student_wellness.phone_in_canada')"
              :value.sync="innerItem.PhoneInCanada"
              clearable
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              :label="
                $t('components.portal.student_wellness.direct_dial_phone')
              "
              :value.sync="innerItem.DirectDialPhone"
              clearable
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <image-picker
              :value.sync="innerItem.SchoolLogo"
              :label="$t(`components.portal.student_wellness.school_logo`)"
            ></image-picker>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <color-selector
              :value.sync="innerItem.MainColor"
              :hexColorsOnly="true"
              :label="$t('components.portal.student_wellness.main_color')"
            ></color-selector>
          </v-col>
        </v-layout>
      </v-form>
    </v-card-text>
  </expandable-material-card>
</template>

<script>
import { mapGetters } from "vuex";
import ImagePicker from "./ImagePicker.vue";
import ColorSelector from "./ColorSelector.vue";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
import ExpandableMaterialCard from "./ExpandableMaterialCard.vue";

export default {
  components: {
    ImagePicker,
    ColorSelector,
    NoAutocompleteTextfield,
    ExpandableMaterialCard,
  },
  props: ["portal"],
  data() {
    return {
      valid: false,
      innerItem: {},
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    portal: {
      handler(v) {
        if (v !== null && v !== undefined) {
          // console.log(
          //   "student wellness data container portal change: ",
          //   JSON.stringify(v)
          // );
          if (v.studentWellness !== null && v.studentWellness !== undefined) {
            this.innerItem = JSON.parse(JSON.stringify(v.studentWellness));
          } else {
            this.innerItem = {};
          }
        }
      },
    },
    innerItem: {
      handler(v) {
        // console.log("student wellness update", JSON.stringify(v));
        this.$emit("update", v);
      },
    },
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
  },
  mounted() {
    // console.log(
    //     "student wellness mounted: ",
    //     JSON.stringify(this.portal)
    //   );
    if (this.portal !== null && this.portal !== undefined) {
      if (
        this.portal.studentWellness !== null &&
        this.portal.studentWellness !== undefined
      ) {
        this.innerItem = JSON.parse(
          JSON.stringify(this.portal.studentWellness)
        );
      } else {
        this.innerItem = {};
      }
      this.$nextTick(() => {
        this.$emit("valid", this.valid);
      });
    }
  },
};
</script>
